import React from "react"

import ComponentFactory from "../components/parsers/ComponentFactory"

import SuggestedContentSection from "./SuggestedContentSection"

import withRecombee from "../contexts/withRecombee"

import * as doubleColumnSectionStyles from "../styles/DoubleColumnSection.module.css"

const filteredContent = components => {
  if (!components || !components.type || components.type !== `div`)
    return components

  const isDoubleColumnText =
    components.props &&
    components.props.className &&
    components.props.className
      .trim()
      .split(/\s+/)
      .includes(`double-column-section`)
  if (!isDoubleColumnText) return components

  const textStack = components.props.children
  if (!textStack) return components

  let filteredTextStack = []
  let doubleColumnText = null
  textStack.forEach(elem => {
    if (
      elem.type !== `div` ||
      !elem.props.className
        .trim()
        .split(/\s+/)
        .includes(`icw-double-column-section-content`)
    ) {
      filteredTextStack.push(elem)
      return
    }

    const item =
      elem.props.dangerouslySetInnerHTML &&
      elem.props.dangerouslySetInnerHTML.__html
    if (!item) filteredTextStack.push(elem)

    const filteredHtml = item
      .replace(/<p[^>]*>/g, "")
      .replace(/<\/p>/g, "<br /><br />")

    if (!doubleColumnText) {
      elem.props.dangerouslySetInnerHTML.__html = filteredHtml
      doubleColumnText = elem
    } else {
      doubleColumnText.props.dangerouslySetInnerHTML.__html += filteredHtml
    }
  })

  doubleColumnText.props.dangerouslySetInnerHTML.__html =
    `<p class="double-column-section-content">` + doubleColumnText.props.dangerouslySetInnerHTML.__html + `</p>`
  filteredTextStack.push(doubleColumnText)

  return filteredTextStack
}

function DoubleColumnSection(props) {
  const { content, pageContext } = props

  const [genericContent, setGenericContent] = React.useState(false)
  const [recommendedContent, setRecommendedContent] = React.useState(null)

  React.useEffect(() => {
    async function fetchContent() {
      const res = await props.recombee.RecommendItemsToUser(3, "medium")
      if (!res || !res.recomms || !res.recomms.length) {
        setGenericContent(true)
      } else {
        setRecommendedContent(
          res.recomms.map(r => ({
            title: r.values.title,
            synopsis: r.values.excerpt,
            categories: r.values.categories,
            link: r.values.uri,
          }))
        )
      }
    }

    if (props.recombee && props.recombee.userId) {
      if (props.recombee.client) fetchContent()
    } else {
      setGenericContent(true)
    }
  }, [props.recombee, props.recombee.client])

  const contentWrapperProps = {
    className: "double-column-section",
  }
  const components = ComponentFactory(content.innerHTML, contentWrapperProps)

  return (
    <div
      className={`row cubewise-double-column-section ${doubleColumnSectionStyles.wrapper} ${props.className}`}
    >
      {!recommendedContent && (
        <div
          className={`col-12 ${
            genericContent ? `` : doubleColumnSectionStyles.invisibleContent
          }`}
        >
          {filteredContent(components)}
        </div>
      )}

      {recommendedContent && (
        <div className={`col-12`}>
          <SuggestedContentSection
            withWrapper={false}
            content={recommendedContent}
            pageContext={pageContext}
          />
        </div>
      )}
    </div>
  )
}

export default withRecombee(DoubleColumnSection)
